import React from 'react';
import { connect } from 'react-redux';
import URI from 'urijs';

// ducks
import { ADD_FAVORITE, REMOVE_FAVORITE, isFavorite } from '../../ducks/FavoriteSearch';

// components
import PropertyCard from '../../partials/property-card/property-card';

// modules
import styles from '../Containers.module.scss';

// images
import notfound from './images/notfound.png';

function PropertyResult({
  searchURI,
  record,
  search,
  availabilityType,
  isFavorite,
  ADD_FAVORITE,
  REMOVE_FAVORITE
}) {
  return (
    <PropertyCard
      data={record}
      className={styles.searchResult}
      searchURI={searchURI}
      availabilityType={availabilityType}
      isFavorite={isFavorite}
      onFavoriteClick={() =>
        isFavorite ? REMOVE_FAVORITE(record.id) : ADD_FAVORITE(record)
      }
      placeholderImg={notfound}
    />
  );
}

export default connect(
  (state, props) => {
    const { pathname, search = {} } = state.routing.location;
    const { record } = props;
    return {
      searchURI: pathname && URI(pathname).search(search).toString(),
      availabilityType: state.PropertySearch.getIn([
        'list',
        'filters',
        'availabilityType'
      ]),
      isFavorite: isFavorite(state, record.id)
    };
  },
  {
    ADD_FAVORITE,
    REMOVE_FAVORITE
  }
)(PropertyResult);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertyResult.js